import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchUser } from '../actions/user';
import { setDefaultTimezone } from '../utils/timezone';

function NewVideoLayout({
  authenticated = false,
  children,
  fetchUser: fetchUserAction,
}) {
  useEffect(() => {
    if (authenticated) {
      fetchUserAction(response => setDefaultTimezone(response.data));
    }
  }, []);

  if (authenticated) {
    return <div>{children}</div>;
  }
  return <div>{children}</div>;
}

NewVideoLayout.propTypes = {
  fetchUser: PropTypes.func.isRequired,
  authenticated: PropTypes.bool,
  children: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    user: state.user,
  };
}

export default withRouter(
  connect(mapStateToProps, { fetchUser })(NewVideoLayout),
);
